import React from 'react';
import { Outlet, useNavigate } from 'react-router-dom';
import ModalWrapper from '../shared/modal/Modal.wrapper';

type Props = {
  overlayClose?: boolean;
};

export function ModalLayout({ overlayClose = true }: Props) {
  const navigate = useNavigate();

  return (
    <ModalWrapper open={true} onClose={() => navigate(-1)} overlayClose={overlayClose}>
      <Outlet />
    </ModalWrapper>
  );
}
